import {
  getSessionClientInformation,
  getSessionUserInformation,
} from "app/utils/utility.service";
import React, { forwardRef, Fragment, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { InputSwitch } from "primereact/inputswitch";

import { Button } from "primereact/button";

import {
  calculatePropertyIncome,
  getAccounts,
  getCommodities,
  getCommoditiesStats,
  getCrypto,
  getCryptoStats,
  getDepletionDetails,
  getDepletionDetailsByUserId,
  getFinancials,
  getFinancialsStats,
  getLifeEventDetails,
  getNetworthProjectionValues,
  getPropertyDetails,
  getUserAssumptions,
} from "../homepurchase.service";

import LineChartIncome from "./LineChartIncome";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getIncomeReportRecords } from "app/utils/utility.service";
import { useSelector } from "react-redux";
import { getUserSettings } from "app/views/sessions/SessionSlice";
import moment from "moment";
import { FormatAmount } from "app/utils/utility.service";
import { getSessionClientSettings } from "app/utils/utility.service";
import { getSessionUserSettings } from "app/utils/utility.service";


/* ------------------ Utils ------------------ */

const generateYears = () => {
  const start = new Date().getFullYear();
  const years = [];
  for (let y = start; y <= start + 30; y += 2) {
    years.push(y);
  }
  return years;
};

const projectValues = (value, rate, years) =>
  years.map((_, i) =>
    Number(value * Math.pow(1 + rate / 100, i)).toFixed(0)
  );

/* ------------------ Printable Component ------------------ */

const ComponentToPrint = forwardRef((props, ref) => {
  const { accounts, showChart,reportData, lifeEvents} = props;
  const years = generateYears();

  /*const datasets = accounts.map(acc => {
    const total = acc.accountCategories.reduce(
      (s, c) => s + Number(c.value || 0),
      0
    );

    const rate =
      acc.accountCategories.find(c => c.annualGrowth)?.annualGrowth || 5;

    return {
      label: acc.account_name,
      data: projectValues(total, rate, years),
      borderWidth: 3,
      tension: 0.4
    };
  });

  const chartData = {
    labels: years,
    datasets
  };*/

 /* const tableRows = accounts.flatMap(acc =>
    acc.accountCategories.map(cat => ({
      section: acc.account_name,
      asset: cat.name,
      growth: `${cat.annualGrowth || "-"} %`
    }))
  );*/
  const baseYear = Number(moment().format("YYYY"));
  const [chartData, setChartData] = useState(
    reportData
  );
  return (
    <div ref={ref}>
   

      {showChart ? 
      <LineChartIncome chartData={chartData} lifeEvents={lifeEvents} years={years} />
        :
        <div className="Reports">
          <div className="HomePrice right ml-4 ">
         <div className="HomeValueTable mb-4 widthCls">
        <Fragment>
          
        <div className="flex">
            <h3 className="col-12 text-align-center">Income Projection</h3>
          </div>
      <DataTable value={reportData} className="mt-4">
        <Column field="year" header="Year" />
        <Column field="plannedExpenses" header="Planned Expenses"  body={(rowData) =>
                rowData.plannedExpenses
                  ? FormatAmount((rowData.plannedExpenses))
                  : "0"
              } />
        <Column field="brokerageIncome" header="Income from Brokerage Accounts"  body={(rowData) =>
                rowData.brokerageIncome
                  ? FormatAmount((rowData.brokerageIncome))
                  : "0"
              } />
     
       
        <Column field="propertyIncome" header="Property Income" body={(rowData) =>
                rowData.propertyIncome
                  ? FormatAmount((rowData.propertyIncome))
                  : "0"
              }/>
         <Column field="otherIncome" header="Income from Other Sources" body={(rowData) =>
                rowData.otherIncome
                  ? FormatAmount((rowData.otherIncome))
                  : "0"
              }/>
        <Column field="depletion" header="Depletion" body={(rowData) =>
                rowData.depletion
                  ? FormatAmount((rowData.depletion))
                  : "0"
              }/>
        <Column field="surplus" header="Surplus" body={(rowData) =>
          rowData.surplus
            ? FormatAmount((rowData.surplus))
            : "0"
          
        }/>
      </DataTable>
      </Fragment>
      </div>
      </div>
      </div>
      }
    </div>
  );
});

/* ------------------ Main Component ------------------ */

const IncomeProjectionReport=()=> {
  const [accounts, setAccounts] = useState([]);
  const [depletions, setDepletions] = useState([]);
  const [lifeEvents, setLifeEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [propertyIncome, setPropertyIncome] = useState([]);
  const [showChart, setShowChart] = useState(true);
  const [isPrinting, setIsPrinting] = useState(false);
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientid");
  const navigate = useNavigate();
  const [showMore, setShowMore] = useState(false);
  const [graphRecords, setGraphRecords] = useState([]);
  const componentRef = useRef();
  const promiseResolveRef = useRef(null);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [userSettingsProperty, setUserSettingsProperty] = useState(null);
    const [userSettingsInv, setUserSettingsInv] = useState(null);
  const userSettings = useSelector(getUserSettings);
  console.log(userSettings)
  const [chartMode, setChartMode] = useState("ACCOUNT"); 
  const [loading, setLoading] = useState(true);
  let sessionValues =
      clientId && clientId !== "null"
        ? getSessionClientInformation()
        : getSessionUserInformation();
    const clientInfo = getSessionClientInformation();
    if (clientInfo) {
      sessionValues = clientInfo;
    }

  const [propertyDetails, setPropertyDetails] = useState([]);

  const fetchPropertyDetails = async () => {
      const userId =
        clientId && clientId !== "null" ? clientId : sessionValues.id;
      let list = await getPropertyDetails(userId);
      if (list!= null && list.length >0) {
        setIsLoading(false);
       
        setPropertyDetails(list);
       
      } 
    }
  const getAccountDetails = async () => {
    setIsLoading(true);
    const userId =
      clientId && clientId !== "null" ? clientId : sessionValues?.id;
    const data = await getAccounts(userId);
    const filterAssetAccounts = (accounts = []) =>
    data.filter(acc => acc.type === "Assets");
    setAccounts(filterAssetAccounts);
   
    let fetchedUserSettings = null;
    if (clientId && clientId !== "null") {
      fetchedUserSettings = getSessionClientSettings();
    } else {
      fetchedUserSettings = getSessionUserSettings();
    }
    setUserSettingsProperty(fetchedUserSettings);
    const payload = {
      userId: userId,
    };
    const record = await getUserAssumptions(payload);
    setUserSettingsInv(record);
    setIsLoading(false);
  };
   const getPropertyIncomeDetails = async () => {
    setIsLoading(true);
    const userId =
      clientId && clientId !== "null" ? clientId : sessionValues?.id;
   
    const propIncome = await calculatePropertyIncome(userId);
    console.log("Property income "+JSON.stringify(propIncome));
    setPropertyIncome(propIncome);
    setIsLoading(false);
  
  };
   const getLifeEvents = async () => {
    setIsLoading(true);
    const userId =
      clientId && clientId !== "null" ? clientId : sessionValues?.id;

    const lifeEvents = await getLifeEventDetails(userId);
    setLifeEvents(lifeEvents);
    setIsLoading(false);
  };
   const getDepletions = async () => {
    setIsLoading(true);
    const userId =
      clientId && clientId !== "null" ? clientId : sessionValues?.id;

    const dep = await getDepletionDetails(userId);
    setDepletions(dep ? dep.filter((d) => d.startDate != null) : []);
    setIsLoading(false);
  };
    const handleShowMore = () => {
    setShowMore(!showMore);
  };
 const getComponentToPrint = (showButton) => {
    let totalHomeValueElements = [];
    let totalHomeLabelElements = [];
    if (graphRecords?.totalHomeValue?.length > 0) {
      graphRecords?.totalHomeValue.forEach((element, index) => {
        if (index === 0) {
          totalHomeValueElements.push(Number(element).toFixed(0));
        } else {
          if (index % 3 === 0) {
            totalHomeValueElements.push(Number(element).toFixed(0));
          }
        }
      });
      if (graphRecords?.labels?.length > 0) {
        graphRecords?.labels.forEach((element, index) => {
          if (index === 0) {
            totalHomeLabelElements.push(element);
          } else {
            if (index % 3 === 0) {
              totalHomeLabelElements.push(element);
            }
          }
        });
      }
    }
    return (
          <ComponentToPrint
        ref={componentRef}
        accounts={accounts}
        showChart={showChart}
        lifeEvents={lifeEvents}
         reportData={graphRecords.initialReportData}
         labels={totalHomeLabelElements}
      />
    );
  };
  useEffect(() => {
    Promise.all([
      getAccountDetails(),
      getLifeEvents(),
      getDepletions(),
      getPropertyIncomeDetails(),
      fetchPropertyDetails()
    ]).then(() => {
      setLoading(false); // All API calls finished
    });

     
  }, []);

  /* ----------- Print Handling ----------- */

  useEffect(() => {
    if (isPrinting && promiseResolveRef.current) {
      promiseResolveRef.current();
    }
  }, [isPrinting]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () =>
      new Promise(resolve => {
        promiseResolveRef.current = resolve;
        setIsPrinting(true);
      }),
    onAfterPrint: () => {
      promiseResolveRef.current = null;
      setIsPrinting(false);
    }
  });

  /* ----------- Render ----------- */

 
useEffect(() => {
  
   if (!loading) {
        setGraphRecords(
        getIncomeReportRecords(
          accounts,propertyIncome, lifeEvents,depletions, userSettingsProperty,userSettingsInv, propertyDetails
        ));
   }
   
  }, [
    loading,
   accounts, propertyIncome, depletions
  ]);

  return (
    <Fragment>

      <div className="align-text-rt mt-4" style={{ width: "98%" }}>
              <label className="mb-3 mr-3" style={{ fontSize: "1.2rem" }}>
                Table View
              </label>
              <InputSwitch
                style={{ transform: "scale(1.25)", transformOrigin: "left" }}
                checked={showChart}
                onChange={(e) => {
                  setShowChart(e.value);
                }}
              ></InputSwitch>
              <label className="mb-3 ml-4" style={{ fontSize: "1.2rem" }}>
                Chart View
              </label>
            </div>

  {!isLoading && graphRecords?.labels?.length > 0 ? (
    <Fragment>
  

       {getComponentToPrint(isPrinting)}
            <div style={{ margin: "2rem", textAlign: "end" }}>
              <Button
                label="Print Report"
                className="p-button-raised p-button-warning mr-2"
                onClick={handlePrint}
              />
              <Button
                label="Cancel"
                className="p-button-raised p-button"
                onClick={() => navigate(-1)}
              />
              <div></div>
            </div>
            </Fragment>
             ) : (
        <p>Please store the data to print the report.</p>
      )}
    </Fragment>
  );
}

export default IncomeProjectionReport;
